module.exports = __webpack_public_path__ + "static/media/Waktunya Main.3a37ab5b.PNG";